<template>
  <div class="app-container">
    <el-form ref="form" label-position="left" label-width="120px" size="small" :model="ruleForm" :rules="rules">
      <el-form-item class="w500" prop="title" label="轮播图标题">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item class="w500" prop="href" label="链接">
        <el-input v-model="ruleForm.href"></el-input>
      </el-form-item>
      <el-form-item class="w500" prop="cover" label="上传图片">
        <imgUpload v-model="ruleForm.cover"></imgUpload>
        <label>建议尺寸为640*384像素，大小小于2M</label>
      </el-form-item>
      <el-form-item class="w250" prop="list_order" label="排序">
        <el-input v-model="ruleForm.list_order"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button type="primary" :loading="submitLoading" @click="formSubmit"> 确定 </el-button>
      <el-button @click="backList">取消</el-button>
    </div>
  </div>
</template>
<script>
import imgUpload from "@/components/pub/imgUploadNormal";
import { editBanner, addBanner, bannerDetail } from "@/api/operation.js";
export default {
  components: {
    imgUpload,
  },
  data() {
    return {
      ruleForm: {},
      submitLoading: false,
      rules: {
        title: [
          {
            required: true,
            message: "请输入轮播图标题",
            trigger: "blur",
          },
        ],
        href: [
          {
            required: true,
            message: "请输入轮播图标题",
            trigger: "blur",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传轮播图",
            trigger: "blur",
          },
        ],
        list_order: [
          {
            required: true,
            message: "排序不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.ruleForm = this.$route.query;
    // this.ruleForm.cover = 'https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/train_service/app_upload/812b78d0c7b624f553782bc4bac4bc85.jpg'
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
  },
  methods: {
    async getDetail(uuid) {
      const res = await bannerDetail(uuid);
      if (res) {
        this.ruleForm = res;
      }

      console.log(res);
    },
    formSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // this.submitLoading = true;
          if (this.ruleForm.id) {
            this.subEdit();
          } else {
            this.subAdd();
          }
        }
      });
    },
    async subAdd() {
      const res = await addBanner(this.ruleForm);
      if (res) {
        this.$message.success("成功");
        this.$router.go(-1);
      }
    },
    async subEdit() {
      const res = await editBanner(this.ruleForm, this.ruleForm.id);
      if (res) {
        this.$message.success("成功");
        this.$router.go(-1);
      }
    },
    backList() {
      this.$router.push({
        path: "/swiper",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.w500 {
  width: 500px;
}

.w250 {
  width: 250px;
}
</style>
